import NewForm from "components/NewForm";
import PageDefault from "components/PageDefault";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import companyService from "services/company.service";
import extractFormData from "utils/extractFormatData";
import { formatDocument } from "utils/format";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";
import fundService from "services/fund.service";
import { useTranslation } from "react-i18next";
import fundTypesService from "services/fund.types.service";
import actionPaymentService from "services/payment.service";

export default function BudgetForm() {
  const location = useLocation();
  const history = useHistory();

  const [data, setData] = useState<any>({});

  const [companies, setCompanies] = useState<any[]>([]);
  const [types, setTypes] = useState<any[]>([]);
  const [paymentMethods, setPaymentMethods] = useState<any[]>([]);

  const { t } = useTranslation();

  useEffect(() => {
    fundTypesService.get().then(data=>
      setTypes(data.map((d:any)=>({ value: d.id, name: d.name})))
    )
    actionPaymentService.get().then(data=>
      setPaymentMethods(data.map((d:any)=>({ value: d.id, name: d.name})))
    )
  },[])

  useEffect(() => {
    function getCompanies() {
      companyService.get({
        params: {
          fields: "id,name,document"
        }
      }).then((data) => {
        setCompanies(data.map((item: any) => {
          return { value: item.id, name: `${item.name} - ${formatDocument(item.document)}` };
        }));
      });
    }
    if (location && location.state) {
      let state: any = location.state;
      if (state.company_id) {
        companyService.show(state.company_id, {
          params: {
            fields: "id,name,document"
          }
        }).then((data) => {
          setCompanies([data].map((item: any) => {
            return { value: item.id, name: `${item.name} - ${formatDocument(item.document)}`, fund_model: item.fund_model };
          }));
          setData({ company_id: data.id })
        });
      } else { getCompanies() }
    } else {
      getCompanies()
    }
  }, [location]);

  function submit() {
    let formdata = new FormData();
    extractFormData(data, formdata);

    fundService.store(formdata).then((data: any) => {
      history.goBack();
    })
  }

  return (
    <PageDefault title={t("budget:form:title")}>
      <PageDefault.Title>{t("budget:form:title")}</PageDefault.Title>
      <PageDefault.Content>
        <NewForm title={"Dados da Verba"}>
          <NewForm.SelectSearch title={t("budget:form:labels:manufacturer")} name="company_id" md="4" options={companies} state={{ model: data, setModel: setData }} />
          <NewForm.SelectSearch title={t("budget:form:labels:payment_method_id")} name="payment_method_id" md="4" options={paymentMethods}  state={{ model: data, setModel: setData }}/>
          <NewForm.SelectSearch title={t("budget:form:labels:fund_type_id")} name="fund_type_id" md="4" options={types}  state={{ model: data, setModel: setData }}/>
          <NewForm.InputMoney title={t("budget:form:labels:value")} name="value" md="4" state={{ model: data, setModel: setData }}/>
          <NewForm.Date title={t("budget:form:labels:fund_date")} name="fund_date" md="4" state={{ model: data, setModel: setData }} />
          <NewForm.Files title={t("budget:form:labels:anexo")} name="files" md="12" state={{ model: data, setModel: setData }} />
          <NewForm.Textarea title={t("budget:form:labels:observation")} name="observation" md="12" state={{ model: data, setModel: setData }} />
        </NewForm>
      </PageDefault.Content>
      <PageDefault.Footer>
        <Button size="sm" onClick={submit}>Salvar</Button>
      </PageDefault.Footer>
    </PageDefault>
  )
}